import React from 'react';
import IncomeDetailsNetMonthlyIncomeSection
  from 'Components/Universal/Questionnaire/ResourceSections/IncomeDetails/IncomeDetailsNetMonthlyIncomeSection';

const IncomeDetailsNetMonthlyIncomePicker = ({ clientResource, ...rest }) => {
  return <IncomeDetailsNetMonthlyIncomeSection {...rest} isPrimary={clientResource?.attr('isPrimary') === 'true'} />;
};

export default IncomeDetailsNetMonthlyIncomePicker;
